var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4313 7L8.84555 13.5858C8.0645 14.3668 8.0645 15.6332 8.84555 16.4142C9.6266 17.1953 10.8929 17.1953 11.674 16.4142L18.0882 9.82843C19.6503 8.26633 19.6503 5.73367 18.0882 4.17157C16.5261 2.60948 13.9934 2.60948 12.4313 4.17157L6.01713 10.7574C3.67398 13.1005 3.67398 16.8995 6.01713 19.2426C8.36027 21.5858 12.1593 21.5858 14.5024 19.2426L20.7598 13",
    stroke: "#8F9BBA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper-clip.58eb1c015214e02993a00d578b09998c.svg";
export { ForwardRef as ReactComponent };